import AsyncContent from './index.js';

export default class AsyncContentForCart extends AsyncContent {
  static get observedAttributes() {
    return [...super.observedAttributes, 'css-url', 'js-url'];
  }

  constructor() {
    super();
  }

  attributeChangedCallback(name, oldValue, value) {
    super.attributeChangedCallback(name, oldValue, value);

    if (oldValue === value || value === null) {
      return;
    }

    if (name === 'css-url') {
      this.css = value;
    }

    if (name === 'js-url') {
      this.js = value;
    }
  }

  async loadContent(isUpdate) {
    await super.loadContent(isUpdate);

    if (this.css) {
      const temp = this.innerHTML;
      this.innerHTML = '<div class="f-asynccontent__loader"></div>';

      await new Promise((resolve, reject) => {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = this.css;

        link.addEventListener('load', () => resolve());
        link.addEventListener('error', (e) => reject(e));

        this.append(link);
      });

      this.innerHTML += temp;

      if (this.querySelector('.f-asynccontent__loader')) {
        this.querySelector('.f-asynccontent__loader').remove();
      }
    }

    if (this.js) {
      const script = document.createElement('script');
      script.src = this.js;
      this.append(script);
    }
  }
}

customElements.get('f-asynccontentforcart') || customElements.define('f-asynccontentforcart', AsyncContentForCart);
